import { useEffect } from "react"
import { useCurrentAvailableProductsForPage } from "~/hooks/useCurrentAvailableProductsForPage"
import { registerGlobalFunction } from "../register"

interface Props {}

const FuncGetPageProducts: React.FC<Props> = () => {
  const { products } = useCurrentAvailableProductsForPage()

  useEffect(() => {
    if (window) {
      registerGlobalFunction("getPageProducts", () => products)
    }
  }, [products])

  return null
}

export default FuncGetPageProducts
